import React from 'react';

import type { RouteObject } from 'react-router-dom';

const GasDistributionStationInformation = React.lazy(
  () => import('@/pages/GasDistributionStationDetails/views/Information'),
);

const GasDistributionStationGasThreads = React.lazy(
  () => import('@/pages/GasDistributionStationDetails/views/GasThreads'),
);

export const gasDistributionStationRoutes: RouteObject[] = [
  {
    element: <GasDistributionStationInformation />,
    index: true,
  },
  {
    path: `gas-threads`,
    element: <GasDistributionStationGasThreads />,
  },
];
